// extracted by mini-css-extract-plugin
module.exports = {"description":"_52d1a1b0"};